import React from 'react'
import { CartOutline, ChatbubbleEllipsesOutline, DownloadOutline, LayersOutline, OptionsOutline, PricetagOutline } from 'react-ionicons'
import { generatePath, NavLink } from 'react-router-dom'

import { Nav, Navbar } from 'rsuite'

import { usePartner } from '@@partner:helpers/hooks/auth'

import {
  ROUTE_CATALOG,
  ROUTE_CATALOG_CATEGORIES,
  ROUTE_CATALOG_EXPORT,
  ROUTE_CATALOG_PRODUCT_REVIEWS,
  ROUTE_PRODUCT_ATTRIBUTES,
  ROUTE_PRODUCT_GROUPS
} from '@@partner:config/routes'

export default function CatalogTopMenu () {
  const { brandSlug } = usePartner()

  return (
    <Navbar>
      <Nav>
        <Nav.Item
          icon={<CartOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG, { brandSlug })}
        >Товары</Nav.Item>
        <Nav.Item
          icon={<PricetagOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_CATEGORIES, { brandSlug })}
        >Категории</Nav.Item>
        <Nav.Item
          icon={<LayersOutline />}
          as={NavLink}
          to={generatePath(ROUTE_PRODUCT_GROUPS, { brandSlug })}
        >Группы товаров</Nav.Item>
        <Nav.Item
          icon={<OptionsOutline />}
          as={NavLink}
          to={generatePath(ROUTE_PRODUCT_ATTRIBUTES, { brandSlug })}
        >Атрибуты товаров</Nav.Item>
        <Nav.Item
          icon={<ChatbubbleEllipsesOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_PRODUCT_REVIEWS, {
            brandSlug
          })}
        >Отзывы на товары</Nav.Item>
        <Nav.Item
          icon={<DownloadOutline />}
          as={NavLink}
          to={generatePath(ROUTE_CATALOG_EXPORT, { brandSlug })}
        >Экспорт</Nav.Item>
      </Nav>
    </Navbar>
  )
}